import useAnalytics from "@/composables/useAnalytics";

// cacheUtils.js
const CACHE_PREFIX = "vue-app-cache-";
const { removeAffiliateLink } = useAnalytics();
const LINK_STATUS = {
  override: "overwritten",
  expired: "expired",
};

export function setCache(key, value, ttl = 7 * 24 * 60 * 60 * 1000) {
  // we want to check if an affiliate link is being overwritten in the user's device.
  let currentValue = getCache(key);

  if (String(currentValue) !== String(value) && currentValue) {
    removeAffiliateLink(currentValue, LINK_STATUS.override, value);
  }

  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(item));
}

export function getCache(key) {
  const itemStr = localStorage.getItem(`${CACHE_PREFIX}${key}`);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    removeAffiliateLink(item.value, LINK_STATUS.expired);
    localStorage.removeItem(`${CACHE_PREFIX}${key}`);
    return null;
  }
  return item.value;
}
